import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Home from "./components/Home";
import About from "./components/About";
import Team from "./components/Team";
import HairStyling from "./components/HairStyling";
import HairColoring from "./components/HairColoring";
import HairTexturing from "./components/HairTexturing";
import Waxing from "./components/Waxing";
import NailCare from "./components/NailCare";
import OtherCare from "./components/OtherCare";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import FacialCare from "./components/FacialCare";
import NoMatch from "./components/NoMatch";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/hair-styling" element={<HairStyling />} />
          <Route path="/hair-coloring" element={<HairColoring />} />
          <Route path="/hair-texturing" element={<HairTexturing />} />
          <Route path="/facial-care" element={<FacialCare />} />
          <Route path="/waxing" element={<Waxing />} />
          <Route path="/nail-care" element={<NailCare />} />
          <Route path="/other-care" element={<OtherCare />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;





